export const MicrophoneStreamError = {
  PermissionDenied: 'microphone-permission-denied',
  RecorderError: 'microphone-recorder-error',
  RecorderUnsupported: 'recorder-unsupported',
  Unavailable: 'microphone-unavailable',
}
